import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.css';

// 스크롤 시 살짝 떠오르는 효과 (v-reveal)
const reveal = {
  mounted(el) {
    el.classList.add('reveal');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.classList.add('is-visible');
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          el.classList.add('is-visible');
          io.disconnect();
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
    setTimeout(() => { el.classList.add('is-visible'); io.disconnect(); }, 3000);
  },
};

createApp(App).use(router).directive('reveal', reveal).mount('#app');
